import { LoadingSpinner } from "../../../components/LoadingSpinner"
import { Patient } from "../../../utils/api-objects/Patient"
import { Folder } from "../../../utils/Enums"

interface FolderProps {
    folder: Folder,
    pointer: boolean,
    textTwo?: string,
    textThree?: string,
    onClick?: () => void,
    isLoading?: boolean,
    patient?: Patient,
}

export const FolderBox: React.FC<FolderProps> = ({
    folder,
    pointer,
    textTwo,
    textThree,
    onClick,
    isLoading = false,
    patient,
}) => {
    const handleFolderName = () => {
        switch (folder) {
            case Folder.HealthAssessment:
                return "📝  Health Assessment"
            case Folder.DnaTest:
                return "🧬  DNA Test Complete"
            case Folder.BloodTest:
                return "🩸  Analisi degli Aminoacidi"
            case Folder.ResultsAndProgresses:
                return "📊  Risultati e progressi"
            case Folder.SharedFromEquipe:
                return "🗂️  Caricati dall'Equipe Medica"
            case Folder.SharedFromPatient:
                return `🗂️  Caricati da ${patient?.user_name}`
            case Folder.PrivateDocuments:
                return "🔒  Documenti Privati"
            case Folder.Nutritionist:
                return `👨‍⚕️  ${textTwo === "null null" ? "Nessun nutrizionista associato" : textTwo}`
            case Folder.Physician:
                return `👨‍⚕️  ${textTwo === "null null" ? "Nessun endocrinologo associato" : textTwo}`
            case Folder.HealthPlan:
                return "Health Plan"
            case Folder.MealPlan:
                return "Meal Plan"
        }
    }
    let textTwoReal = textTwo
    if (textTwo === "null null") textTwoReal = undefined
    return (
        <div
            className={`w-full h-[90px] flex items-center rounded-[5px] shadow-platform ${(pointer && !isLoading) ? "cursor-pointer" : "cursor-not-allowed"} px-[20px] py-[10px]`}
            onClick={() => { if (pointer && !isLoading && onClick) onClick() }}
        >
            <div className="w-full h-full flex items-center justify-between space-x-[10px] overflow-hidden">
                <div
                    className={`font-normal text-sm leading-[33px] ${textTwoReal ? "flex-[0.5] truncate" : "flex-1 whitespace-nowrap"
                        }`}
                >
                    {handleFolderName()}
                </div>
                {/* TextTwo */}
                {(folder !== Folder.Nutritionist && folder !== Folder.Physician) && (
                    <div
                        className={`text-xs w-[20%] min-w-[0] truncate text-ellipsis overflow-hidden 
                            ${textTwo && textThree ? "hidden sm:block" : ""}`}
                    >
                        {textTwo}
                    </div>
                )}

                {/* TextThree and Loading */}
                <div className="text-xs w-[30%] flex justify-end whitespace-nowrap">
                    {isLoading ? <LoadingSpinner /> : textThree}
                </div>
            </div>
        </div>
    )
}